export default "__VITE_ASSET__CqYZ6Gs9__"